















import { Component, Prop, Vue } from 'vue-property-decorator';
import HomeButtonComponent from '@/components/home-button/home-button.component.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import {Getter} from 'vuex-class';
import {AUTH_GET_CLIENT} from '@/store/modules/authentication/types';
import {Client} from '@/store/modules/authentication/interfaces';
import {ClientEnum} from '@/enums/client.enum';

@Component({
  name: 'BusinessPlanPageWrapperComponent',
  components: {
    HomeButtonComponent,
    PageLoader
  }
})
export default class BusinessPlanPageWrapperComponent extends Vue {
  @Prop({ required: false })
  public title: string;

  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  public readonly clientEnum = ClientEnum;
}
